import { cn } from "@/libs/utils";
import DropdownAlt from "../shop/details/DropDownAlt";
import { useState } from "react";

type Props = { onFilter: (year: string) => void; filterableYears: string[] };
const FilterIRByPublishedYear = ({ onFilter, filterableYears }: Props) => {
  const [option, setOption] = useState<string>("전체보기");
  const allOptions = ["전체보기", ...filterableYears];

  return (
    <DropdownAlt label={option} className={cn(`bg-f7f8fa z-20 h-10 w-28`)}>
      <div
        className={`z-30 flex flex-col rounded-md bg-white shadow-[0_2px_10px_0_rgba(0,0,0,0.15)]`}
      >
        {allOptions.map((option, index) => {
          return (
            <button
              key={index}
              className={"p-2 px-4 text-start hover:bg-gray-100"}
              value={option}
              onClick={(e) => {
                // @ts-ignore
                const nextOption = e.target.value;
                setOption(nextOption);
                onFilter(nextOption);
              }}
            >
              {option}
            </button>
          );
        })}
      </div>
    </DropdownAlt>
  );
};
export default FilterIRByPublishedYear;
